import api from "@/services/api";

export default {
  login(params) {
    return api().post("login", params);
  },
  getAccessTokenFromRefreshToken(params) {
    return api().post("login-with-refresh-token", params);
  },
  resendEmailConfirmation(params) {
    return api().post("resend-confirmation", params);
  },
  verifyEmail(params) {
    return api().post("confirm-registration", params);
  },
  register(params) {
    return api().post("register", params);
  },
  forgotPassword(params) {
    return api().post("forgot-password", params);
  },
  resetPassword(params) {
    return api().post("reset-password", params);
  },
  changePasswordOnFirstLogin(params) {
    return api().post("change-password-on-first-login", params);
  },
  logout() {
    return api().post("logout");
  },
  userDetails(params) {
    return api().get("user-detail", params);
  },
  updateProfile(params) {
    return api().post("update", params);
  },
  updateLang(params) {
    return api().post("update-lang", params);
  },
  changePassword(params) {
    return api().post("change-password", params);
  }
};
